<template>
  <div>
    <span style="white-space: nowrap">{{ formatDate(task.end_time) }}</span>
    <div></div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "TaskCompletedDate",
  props: {
    task: {
      type: Object,
      required: true
    }
  },
  methods: {
    formatDate(date) {
      return moment(String(date)).format("DD/MM/YY HH:mm");
    }
  }
};
</script>

<style scoped></style>
